import type { RespuestaBoleto } from '@eventos-cien/shared';
import { Callout } from '../../components/Callout';
import { Eyebrow } from '../../components/Eyebrow';
import { QR } from '../../components/QR';
import { Screen } from '../../components/Screen';

export function Boleto({ boleto }: { boleto: RespuestaBoleto }) {
  const { titular, acompanante, mesa, qrUrl, evento, asistencia } = boleto;
  const yaEntro = asistencia.titular.presente || asistencia.acompanante.presente;

  return (
    <Screen>
      <div className="flex flex-col items-center gap-5 text-center">
        <div className="space-y-1">
          <Eyebrow>{evento.nombre}</Eyebrow>
          <h1 className="text-2xl font-semibold text-texto">Tu lugar está confirmado</h1>
        </div>

        <div
          className="rounded-2xl p-4"
          style={{
            background:
              'linear-gradient(135deg, var(--evento-primario, var(--color-navy)), var(--evento-terciario, var(--color-fondo)))',
          }}
        >
          <QR valor={qrUrl} nombreArchivo={`boleto-${titular.toLowerCase().replaceAll(/\s+/g, '-')}.png`} />
        </div>

        <div className="space-y-1">
          <strong className="block text-lg text-texto">{titular}</strong>
          {acompanante && <span className="text-sm text-texto/60">+ {acompanante}</span>}
        </div>

        <dl className="grid w-full max-w-xs grid-cols-[auto,1fr] gap-x-4 gap-y-1.5 text-left text-sm">
          {mesa && (
            <>
              <dt className="text-texto/50">Mesa</dt>
              <dd className="text-texto">
                {mesa.numero} · {mesa.nombre}
              </dd>
            </>
          )}
          <dt className="text-texto/50">Cuándo</dt>
          <dd className="text-texto">{evento.fechaTexto || 'Por confirmar'}</dd>
          {evento.horaTexto && (
            <>
              <dt className="text-texto/50">Hora</dt>
              <dd className="text-texto">{evento.horaTexto}</dd>
            </>
          )}
          <dt className="text-texto/50">Dónde</dt>
          <dd className="text-texto">{evento.lugarTexto || 'Por confirmar'}</dd>
        </dl>

        {evento.mapsUrl && (
          <a
            className="inline-flex w-full max-w-xs items-center justify-center rounded-full border border-borde bg-white px-5 py-2.5 text-sm font-medium text-navy transition hover:border-navy/40 active:scale-[0.98]"
            href={evento.mapsUrl}
            target="_blank"
            rel="noopener"
          >
            Abrir en Maps
          </a>
        )}

        {yaEntro ? (
          <Callout tono="exito">
            {asistencia.titular.presente && 'Titular ya registrado en la entrada. '}
            {asistencia.acompanante.presente && 'Acompañante ya registrado en la entrada.'}
          </Callout>
        ) : (
          <Callout tono="info">
            Muestra este código en la entrada. Toma una captura para tenerlo a la mano; esta liga
            seguirá funcionando.
          </Callout>
        )}
      </div>
    </Screen>
  );
}
